<template>
    <b-card :title="$translate('filters')" title-tag="h5">
        <b-card-body>
            <b-row>
                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{$translate('complete_from')}}</strong></label>
                        <b-form-input
                            type="date"
                            :max="ratingFilter.completion_date_to"
                            id="input-completion-date_from"
                            v-model="ratingFilter.completion_date_from"
                        ></b-form-input>
                </b-col>

                <b-col md="6" cols="12" class="mt-3">
                    <label class="mb-3"><strong>{{$translate('complete_to')}}</strong></label>
                        <b-form-input
                            type="date"
                            :min="ratingFilter.completion_date_from"
                            id="completion-date_to"
                            v-model="ratingFilter.completion_date_to"
                        ></b-form-input>
                </b-col>
                <b-col md="6" cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>{{$translate('officer')}}</strong></label>
                        <b-form-select
                        class="form-control"
                            id="input-officer"
                            v-model="ratingFilter.driver_id"
                            value-field="id"
                            text-field="name"
                            :options="officers"
                            :disabled="disabledOfficers"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >{{$translate('any_officer')}}</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                </b-col>
                <b-col md="6" cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>{{$translate('role')}}</strong></label>
                        <b-form-select
                        class="form-control"
                            id="input-role"
                            v-model="ratingFilter.role_id"
                            value-field="id"
                            text-field="name"
                            :options="roles"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >{{$translate('any_role')}}</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                </b-col>
                <b-col cols="12" class="mt-3 dd">
                    <label class="mb-3"><strong>{{$translate('rating')}}</strong></label>
                        <b-form-select
                        class="form-control"
                            id="input-status"
                            v-model="ratingFilter.rating"
                            value-field="id"
                            text-field="name"
                            :options="ratting"
                        >
                            <template #first>
                                <b-form-select-option :value="null">
                                    {{ $translate('any_rating') }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'customers-ratingequeryfilters',
    mixins: [permissionsMixins],

    props: ['officers','roles', 'value', 'disabledOfficers'],
    data() {
        return {
            ratting: [
                { id: 1, name: '1' },
                { id: 2, name: '2' },
                { id: 3, name: '3' },
                { id: 4, name: '4' },
                { id: 5, name: '5' },
                // Add more options as needed
            ],
            // Other data properties
        }
    },
    computed: {
        ratingFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
            // setter
            set(val) {
                if (!val.checkoff_type_id) {
                    val.checkoff_completed = null
                }
                val.completion_date_from
                this.$emit('input', val)
            },
        },
        completedValues() {
            return [
                { value: null, text: 'Any' },
                { value: 1, text: 'Yes' },
                { value: 2, text: 'No' },
            ]
        },
        changedValues() {
            return [
                { value: null, text: 'All' },
                { value: 1, text: 'Changed' },
                { value: 2, text: 'Unchanged' },
            ]
        },
    },
    // created() {
    //     this.$store.dispatch('roles/fetchAll')
    // },
    mounted() {
        // this.$store.dispatch('orders/fetchDrivers')
        //init remote filters
    },
    methods: {},
}
</script>
